export const ACTIVE_ORDERS_LIMIT_VALUE = 20
export const PLAN_ORDERS_LIMIT_VALUE = 30
